import { render, staticRenderFns } from "./TheAdvices.vue?vue&type=template&id=35274314&scoped=true&"
import script from "./TheAdvices.vue?vue&type=script&lang=js&"
export * from "./TheAdvices.vue?vue&type=script&lang=js&"
import style0 from "./TheAdvices.vue?vue&type=style&index=0&id=35274314&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35274314",
  null
  
)

export default component.exports